module.exports = __webpack_public_path__ + "static/media/Print.1238e207.svg";